import React, { PureComponent } from "react";

export default class MP extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#338af3"
          />
          <path
            d="M251.469,348.064a9.435,9.435,0,0,1-8.4-6.173h0A9.459,9.459,0,0,1,233.2,345.3h0a9.452,9.452,0,0,1-6.992-7.753h0a9.459,9.459,0,0,1-10.349,1.341h0a9.454,9.454,0,0,1-5.278-9.008h0a9.442,9.442,0,0,1-10.406-.768h0a9.459,9.459,0,0,1-3.357-9.876h0a9.429,9.429,0,0,1-10.034-2.841h0a9.441,9.441,0,0,1-1.317-10.342h0a9.451,9.451,0,0,1-9.259-4.8h0A9.434,9.434,0,0,1,177,290.847h0a9.446,9.446,0,0,1-8.106-6.569h0a9.443,9.443,0,0,1,2.885-10.034h0a9.44,9.44,0,0,1-6.607-8.07h0a9.444,9.444,0,0,1,4.837-9.234h0a9.45,9.45,0,0,1-4.863-9.215h.006a9.453,9.453,0,0,1,6.588-8.094h0a9.455,9.455,0,0,1-2.91-10.022h0a9.459,9.459,0,0,1,8.094-6.6h0a9.459,9.459,0,0,1-.819-10.406h0a9.458,9.458,0,0,1,9.259-4.812h0a9.451,9.451,0,0,1,1.291-10.356h0a9.443,9.443,0,0,1,10.027-2.859h0a9.445,9.445,0,0,1,3.338-9.883h0a9.433,9.433,0,0,1,10.392-.794h0a9.451,9.451,0,0,1,5.259-9.013h0a9.458,9.458,0,0,1,10.355,1.322h0A9.449,9.449,0,0,1,233,168.441h0a9.45,9.45,0,0,1,9.864,3.383h0a9.452,9.452,0,0,1,8.4-6.185h0a9.449,9.449,0,0,1,8.976,5.285h0a9.449,9.449,0,0,1,9.454-4.39h0a9.454,9.454,0,0,1,7.753,6.985h0a9.448,9.448,0,0,1,10.153-2.4h0a9.46,9.46,0,0,1,6.18,8.421h0a9.447,9.447,0,0,1,10.43-.3h0a9.439,9.439,0,0,1,4.346,9.48h0a9.453,9.453,0,0,1,10.273,1.8h0a9.449,9.449,0,0,1,2.356,10.16h0a9.448,9.448,0,0,1,9.706,3.83h0a9.443,9.443,0,0,1,.277,10.425h0a9.461,9.461,0,0,1,8.736,5.7h0a9.468,9.468,0,0,1-1.839,10.28h0a9.442,9.442,0,0,1,7.407,7.351h0a9.473,9.473,0,0,1-3.874,9.688h0a9.444,9.444,0,0,1,5.763,8.68h0v.126h0v.082h0a9.459,9.459,0,0,1-5.744,8.7h0a9.443,9.443,0,0,1,3.892,9.675h0a9.443,9.443,0,0,1-7.388,7.369h0a9.456,9.456,0,0,1,1.864,10.273h0a9.45,9.45,0,0,1-8.731,5.719h0a9.452,9.452,0,0,1-.252,10.43h0a9.446,9.446,0,0,1-9.693,3.849h0a9.459,9.459,0,0,1-2.336,10.167h0a9.465,9.465,0,0,1-10.267,1.826h0a9.455,9.455,0,0,1-4.328,9.492h0a9.449,9.449,0,0,1-10.43-.277h0A9.455,9.455,0,0,1,287.8,342.5h-.007a9.455,9.455,0,0,1-10.16-2.381h0a9.452,9.452,0,0,1-7.735,7.01h0a9.463,9.463,0,0,1-9.466-4.378h0a9.445,9.445,0,0,1-8.49,5.323h0C251.784,348.077,251.627,348.071,251.469,348.064Z"
            fill="#f3f3f3"
          />
          <circle
            cx="62.987"
            cy="62.987"
            r="62.987"
            transform="translate(193.046 193.853)"
            fill="#338af3"
          />
          <path
            d="M269.823,235.464a12.566,12.566,0,0,0,5.109-10.113v-6.3a12.6,12.6,0,0,0-12.6-12.6h-12.6a12.6,12.6,0,0,0-12.6,12.6v6.3a12.566,12.566,0,0,0,5.109,10.113L230.842,351.326s6.3,6.3,25.2,6.3,25.2-6.3,25.2-6.3Z"
            fill="#bdbcc1"
          />
          <path
            d="M256.034,206.455l10.944,33.682H302.4l-28.652,20.818,10.944,33.683-28.654-20.816-28.651,20.816,10.944-33.683-28.652-20.818h35.416Z"
            fill="#f0f0f0"
          />
        </g>
      </svg>
    );
  }
}
